import React from 'react';

function Interests(){
    return(
        <>
        <div className="interest">
            <h2>Interests</h2>
            <p className="text">
            Photographer. Music Aficionado. Reader. Internet fanatic. Badminton lover. 
            Travel geek. Coffee fanatic.
            </p>
        </div>
        </>
    )
}

export default Interests;